import {
    useCallback,
    useEffect,
    useState
} from 'react';
import { TouchableOpacity } from 'react-native';

import {
    Button,
    ButtonsGroup,
    FlatList,
    Modal,
    Modal2,
    Page,
    React,
    Subtitle,
    Title,
    TouchableWithoutFeedback,
    View
} from '../../../common';
import { COLORS } from '../../../styles/colors';
import { BackupSelector } from '../BackupSelector';
import { getDeviceId } from './Backup';
import {
    formatDateSmart,
    formatFileSize
} from './util';

export const BackupItem = ({
    item,
    last = false,
    onClick,
    isIos = false,
    selected,
}) => {
    const deviceName = item?.device?.deviceName;
    const deviceModel = item?.device?.deviceModel;
    const isSelected = item?.id && selected?.id ? item?.id === selected?.id : item?.name === selected?.name;
    const margin = typeof onClick === 'function' ? 16 : 0;
    const itemAppearance = <View style={[
        {
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottomWidth: last ? 0 : 1,
            borderColor: '#E9E9E9',
            marginTop: margin,
        } ]}>
        <Title style={{
            marginTop: margin,
            color: isSelected ? COLORS.MAIN : COLORS.STANDARD_GRAY,
            flexWrap: 'wrap',
        }}>{deviceName} {deviceName && deviceModel ? ' / ' : ''} {deviceModel}</Title>
        <Subtitle style={{
            marginBottom: margin,
            color: isSelected ? COLORS.MAIN : COLORS.STANDARD_GRAY,
        }}>{formatDateSmart(item?.createdTime)}{isIos || (item?.size ?? 0) < 100000 ? '' : `, ${formatFileSize(item?.size ?? 0)}`}</Subtitle>
    </View>;
    return onClick ? (
        <TouchableOpacity
            onPress={() => {
                onClick?.(item);
            }}
            style={{
                flex: 1,
            }}>
            {itemAppearance}
        </TouchableOpacity>) : itemAppearance;
};

export const BackupListForSelect = ({
    data = [],
    selected,
    onSelect,
    isIos,
}) => {
    return <FlatList
        style={{
            // flex: 1,
        }}
        data={data}
        renderItem={({ item }) => <View style={{
            borderWidth: 0,
            marginHorizontal: 16,
        }}>
            <TouchableWithoutFeedback
                onPress={() => {
                    console.log('Item selected in list:', item);
                    onSelect?.(item);
                }}
                key={item?.id}
                style={{
                    flex: 1,
                }}><BackupItem
                    item={item}
                    isIos={isIos}
                    selected={selected}
                    last={false}/>
            </TouchableWithoutFeedback></View>}/>;
};

export const BackupList = ({
    list,
    onSelect,
    attachSize,
    onCancel,
    isIos = false,
}) => {
    const [ data, setData ] = useState([]);
    const [ selectedItem, setSelectedItem ] = useState(null);
    const [ selectorModalOpened, setSelectorModalOpened ] = useState(false);
    const [ deviceId, setDeviceId ] = useState(null);

    useEffect(() => {
        getDeviceId()
            .then((id) => setDeviceId(id));
    }, []);


    useEffect(() => {
        setData(list.map(item => ({
            ...item,
            key: item.id || item.name,
            selected: false,
            size: attachSize,
            onItem: () => {
                onSelect(item);
            },
        })));
    }, [ list,
        onSelect,
        attachSize ]);

    useEffect(() => {
        if (!selectedItem && data && data.length > 0 && deviceId) {
            const found = data.find(d => d?.device?.deviceId === deviceId);
            if (found) {
                setSelectedItem(found);
                return;
            }
            setSelectedItem(data[0]);
        }
    }, [ data,
        selectedItem,
        deviceId ]);

    const onSelectHandler = useCallback(() => {
        onSelect?.(selectedItem ?? data[0]);
        Page.closeModal();
    }, [ onSelect,
        selectedItem,
        data ]);

    const onCancelHandler = useCallback(() => {
        onCancel?.();
        Page.closeModal();
    }, [ onCancel ]);

    const handleChooseWithoutModal = useCallback(() => {
        setSelectorModalOpened(true);
    }, []);

    const onSelectBackupHandler = (item) => {
        setSelectorModalOpened(false);
        setSelectedItem(item);
    };

    return <Modal
        buttonTitle={Object.R('buttons.restoreBackup')}
        buttonCloseTitle={Object.R('buttons.cancel')}
        hideClose
    >
        <View style={{
            padding: 24,
            alignItems: 'center',
        }}>
            <Title style={{ fontWeight: '600' }}>{Object.R('titles.selectBackupForRestore')}</Title>
        </View>
        <BackupSelector
            list={data}
            onClick={handleChooseWithoutModal}
            selectedItem={selectedItem}
            isIos={isIos}
        />
        {selectorModalOpened && <Modal2
            _onClose={() => {
                setSelectorModalOpened(false);
            }}
            title={Object.R('titles.selectBackupForRestore')}>
            <BackupListForSelect
                data={data}
                isIos={isIos}
                selected={selectedItem}
                onSelect={onSelectBackupHandler}/>
        </Modal2>}
        <ButtonsGroup>
            <Button
                transparent
                title="buttons.cancel"
                action={onCancelHandler}
                capitalize
            />
            <Button
                primary
                title="buttons.restoreBackup"
                action={onSelectHandler}
                capitalize
            />
        </ButtonsGroup>
    </Modal>;
};
